import { useEffect, useState } from 'react';
import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import { Toaster } from '@/components/ui/sonner';
import { AuthProvider } from '@/contexts/AuthContext';
import LoginWithCredentials from '@/pages/LoginWithCredentials';
import SuperAdminDashboard from '@/pages/SuperAdminDashboard';
import SchoolRoleSelection from '@/pages/SchoolRoleSelection';
import CEODashboard from '@/pages/CEODashboard';
import DepartmentDashboard from '@/pages/DepartmentDashboard';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

function App() {
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    // Initialize departments on first load
    const initDepartments = async () => {
      try {
        await axios.post(`${API}/init-departments`);
        setInitialized(true);
      } catch (e) {
        console.error('Error initializing departments:', e);
        setInitialized(true);
      }
    };
    initDepartments();
  }, []);

  if (!initialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-lg text-slate-600">Loading...</div>
      </div>
    );
  }

  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<LoginWithCredentials />} />
            <Route path="/super-admin" element={<SuperAdminDashboard />} />
            <Route path="/school-role-selection" element={<SchoolRoleSelection />} />
            <Route path="/school-admin" element={<CEODashboard />} />
            <Route path="/department/:deptId" element={<DepartmentDashboard />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" />
      </AuthProvider>
    </div>
  );
}

export default App;